export default __webpack_public_path__ + "static/media/Icon simple-facebook.0900e2f8.svg";